var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"modal",on:{"click":_vm.close}},[_c('div',{class:{
    container: true,
    shadow: true,
    high: _vm.high,
    width: _vm.width
  }},[_c('div',{staticClass:"padding close"},[_c('router-link',{attrs:{"to":{ name: 'main' },"tag":"button"}},[_c('img',{attrs:{"alt":"Close","src":require("../assets/x-circle.svg")}})])],1),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }